<template>
  <div>
    <el-card style="width: 97%; margin: 0 auto; height: 100%">
      <div class="item-box">
        <div class="Home-item" v-for="(item, index) in list" :key="index">
          <div class="Home-time" @click="onClickList(item.Id)">
            <div class="image-status">
              <img
                v-if="item.IsFinish == 0 && item.Type != 6"
                style="
                  width: 76px;
                  height: 76px;
                  position: absolute;
                  top: 0px;
                  left: 4px;
                  z-index: 2;
                "
                src="../../assets/no_complete.png"
                alt=""
              />
            </div>
            <img
              v-if="item.Img"
              :src="item.Img"
              :class="item.Status == 0 ? 'gray' : ''"
              style="width: 100%; height: 100%"
              alt=""
            />
            <div v-else style="width: 100%; height: 100%" class="defaultIMage">
              <!--   src="../../defaultCover"-->
              <img
                :class="item.Status == 0 ? 'gray' : ''"
                style="width: 100%; height: 100%"
                alt=""
                src="../../assets/defaultCover.png"
              />
              <div class="itemName">
                {{ item.Name }}
              </div>
            </div>
          </div>
          <!-- 多选 -->
          <div style="display: flex">
            <div
              v-if="item.Name == '封底' ? false : true && item.Status == 0"
              class="company-item"
              @click="onClickOpen(item.Id)"
              style="margin-right: 30px"
            >
              开启
            </div>
            <div
              v-if="item.Name == '封底' ? false : true && item.Status == 1"
              class="company-item"
              @click="onClickClose(item.Id)"
              style="margin-right: 30px; background: red"
            >
              关闭
            </div>
            <div
              v-if="item.Name == '封底' ? false : true && item.Status == 1"
              class="company-item"
              @click="onClickEdit(item)"
            >
              编辑
            </div>
            <div
              v-if="item.Name == '封底' ? false : true && item.Status == 0"
              class="company-item"
              style="background: gray"
            >
              编辑
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 20px">
        <div class="btn-confirm" @click="btnConfirm">确定</div>
      </div>
    </el-card>
    <!-- 封面 -->
    <el-dialog title="封面" :visible.sync="dialogVisible" width="30%">
      <div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="display: flex; align-items: center">
            <div style="flex-shrink: 0; width: 85px">小朋友姓名：</div>
            <el-input
              v-model="studentName"
              disabled
              placeholder="请输入姓名"
            ></el-input>
          </div>
          <div style="width: 150px">
            <el-input
              v-model="className"
              disabled
              placeholder="班级"
            ></el-input>
          </div>
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
          "
        >
          <div style="display: flex; align-items: center">
            <div style="flex-shrink: 0; width: 85px">记录人：</div>
            <input
              placeholder="请输入姓名"
              style="
                border: 1px solid #e4e7ed;
                line-height: 30px;
                padding-left: 10px;
              "
              v-model="noteTaker"
            />
          </div>
          <div style="width: 150px"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 寄语 -->
    <el-dialog title="寄语" :visible.sync="dialogSend" width="30%">
      <div>
        <div class="statueTesting">
          <div class="statueTesting_title">内容</div>
        </div>
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入内容"
          v-model="coverContent"
          show-word-limit
          style="padding-top: 20px; border: 1px solid #f5f7fa"
          oninput="if(value.length>200)value=value.slice(0,200)"
        >
        </el-input>
        <prefabricatedText
          :maxTextLength="500"
          MessageType="999"
          @select="coverContentSelect"
        ></prefabricatedText>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSend = false">取 消</el-button>
        <el-button type="primary" @click="submitFn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 五个维度 -->
    <el-dialog
      :title="operationTypeInfo.Name ? operationTypeInfo.Name : ''"
      :visible.sync="dimensionality"
      width="30%"
    >
      <el-dialog
        width="30%"
        title="云盘列表"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="CloudStorageImageBox">
          <div
            class="CloudStorageImageItem"
            v-for="(itemImage, indexImage) in CloudStorageImage"
            :key="indexImage"
            @click="selectImage(indexImage)"
          >
            <div class="check"><div v-if="itemImage.isCheck"></div></div>
            <img :src="itemImage.FileUrl" alt="" />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="affirmSelectImage"
            >确认选择</el-button
          >
        </span>
      </el-dialog>
      <div>
        <div class="statueTesting">
          <div class="statueTesting_title">照片或视频</div>
          <el-button
            size="mini"
            round
            type="primary"
            :disabled="imgFilesLists.length >= 9"
            @click="showCloudStorage"
            >蘑菇云盘获取</el-button
          >
        </div>
        <div class="imgFilesLists">
          <div
            v-for="(file, index) in imgFilesLists"
            :key="index"
            class="fileItem"
          >
            <i @click.stop="removeFileItem(index)" class="el-icon-delete"></i>
            <img
              v-if="file.type == 'image'"
              style="width: 100%; height: 100%"
              :src="file.url"
              alt=""
            />
            <video
              v-else-if="file.type == 'video'"
              style="width: 100%; height: 100%"
              :src="file.url"
              muted
              autoplay
            ></video>
          </div>
          <el-upload
            v-if="imgFilesLists.length < 9"
            action="/api/Img/UploadFile/"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeAvatarUpload"
            :multiple="true"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>

        <div class="statueTesting" style="padding-top: 20px">
          <div class="statueTesting_title">内容</div>
        </div>
        <el-input
          style="border: 1px solid rgb(167 174 187)"
          type="textarea"
          :rows="10"
          show-word-limit
          placeholder="请输入内容"
          v-model="coverContent"
          maxlength="500"
          oninput="if(value.length>500)value=value.slice(0,500)"
        >
        </el-input>

        <prefabricatedText
          :MessageType="operationTypeInfo.Name"
          :maxTextLength="500"
          @select="coverContentSelect"
        ></prefabricatedText>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dimensionality = false">取 消</el-button>
        <el-button type="primary" @click="submitFn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 表格 -->
    <el-dialog title="表格1" :visible.sync="dialogVisibleTable" width="50%">
      <div>
        <el-row class="demo-el-row">
          <el-col :span="12">
            <div class="demo-el-col dark bd-top bd-bottom bd-left bd-right">
              <el-row style="display: flex">
                <el-col :span="6" style="margin-right: 20px">
                  <el-input
                    v-model="tableParams.titleTab1"
                    placeholder="姓名"
                  ></el-input>
                </el-col>
                <el-col :span="17">
                  <el-input
                    v-model="tableParams.name"
                    placeholder="请输入内容"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-top bd-bottom bd-right">
              <el-row style="display: flex">
                <el-col :span="6" style="margin-right: 20px">
                  <el-input
                    v-model="tableParams.titleTab2"
                    placeholder="内容"
                  ></el-input>
                </el-col>
                <el-col :span="17">
                  <el-input
                    v-model="tableParams.content"
                    placeholder="请输入内容"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-bottom bd-left bd-right">
              <el-row style="display: flex">
                <el-col :span="8" style="margin-right: 20px">
                  <el-input
                    v-model="tableParams.titleTab3"
                    placeholder="观察日期"
                  ></el-input>
                </el-col>
                <el-col :span="17">
                  <el-input
                    v-model="tableParams.looktime"
                    placeholder="请输入内容"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="demo-el-col light bd-bottom bd-right">
              <el-row style="display: flex">
                <el-col :span="6" style="margin-right: 20px">
                  <el-input
                    v-model="tableParams.titleTab4"
                    placeholder="记录人"
                  ></el-input>
                </el-col>
                <el-col :span="17">
                  <el-input
                    v-model="tableParams.writename"
                    placeholder="请输入内容"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col v-for="(item, index) in tableParams.List" :key="index">
            <div
              class="demo-el-col light bd-left bd-bottom bd-right"
              style="height: 129px; flex-direction: column"
            >
              <el-row
                style="display: flex; width: 100%; flex-direction: column"
              >
                <el-col :span="6" style="margin: 10px 0 10px 0">
                  <input
                    v-model="item.title"
                    style="font-size: 14px; color: #000; padding-left: 15px"
                    placeholder="请输入标题"
                  />
                </el-col>
                <el-col :span="24">
                  <el-input
                    style="font-size: 14px"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="item.desc"
                  >
                  </el-input>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTable = false">取 消</el-button>
        <el-button type="primary" @click="submitFn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 表格2 -->
    <el-dialog
      :title="operationTypeInfo.Name"
      :visible.sync="dialogTableTwo"
      width="30%"
    >
      <div>
        <div class="table-header">
          <el-row class="demo-el-row">
            <el-col>
              <div
                class="demo-el-col dark bd-top bd-bottom bd-left bd-right"
                style="justify-content: center"
              >
                <input
                  type="text"
                  v-model="params.title"
                  class="input-table"
                  placeholder="例:成长记录(四月)"
                  style="text-align: center; width: 100%"
                />
              </div>
            </el-col>
            <el-col :span="12">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  表现
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  真棒
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  较好
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left bd-right">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  加油
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            class="demo-el-row"
            v-for="(item, index) in params.List"
            :key="index"
          >
            <el-col :span="12">
              <div class="demo-el-col dark bd-bottom bd-left">
                <el-input
                  type="textarea"
                  v-model="item.manifestation"
                  class="input-table"
                  placeholder="请输入表现行为"
                  style="width: 100%; border: none"
                />
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 1
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/stateHui.png')
                    "
                    @click="onClickRate(1, index)"
                    style="width: 26px; height: 26px"
                    alt=""
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left">
                <div
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 2
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/stateHui.png')
                    "
                    lazy-load
                    style="width: 26px; height: 26px"
                    mode=""
                    @click="onClickRate(2, index)"
                  />
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="demo-el-col dark bd-bottom bd-left bd-right">
                <div
                  class=""
                  style="
                    font-size: 14px;
                    font-weight: bold;
                    margin: 0 auto;
                    color: #000;
                  "
                >
                  <img
                    :src="
                      item.isActivite == 3
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/stateHui.png')
                    "
                    lazy-load
                    style="width: 26px; height: 26px"
                    mode=""
                    @click="onClickRate(3, index)"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableTwo = false">取 消</el-button>
        <el-button type="primary" @click="submitFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  FrontGetProceDetailOneInfo,
  FrontGetProceDetailInfo,
  FrontSaveProceDetailOneInfo,
  FrontOpenProceDetailStatus,
  FrontCloseProceDetailStatus,
  FrontGetTableTwoTitle,
  FrontGetProceQuestionInfo,
  GetCloudFilePageingByFolderId,
} from "../../api/api";
import { mapState } from "vuex";
import prefabricatedText from "../../components/PrefabricatedText.vue";

export default {
  data() {
    return {
      list: [],
      dialogVisible: false,
      dialogSend: false,
      dimensionality: false,
      dialogVisibleTable: false,
      dialogTableTwo: false,
      className: "",
      tableParams: {
        List: [],
        titleTab1: "",
        titleTab2: "",
        titleTab3: "",
        titleTab4: "",
        name: "",
        content: "",
        looktime: "",
        writename: "",
        performance: "",
        questionreason: "",
        Problemplan: "",
        change: "",
      },
      params: {
        title: "",
        List: [],
      },
      coverContent: "",
      imgFilesLists: [],
      userInfo: {},
      loadingFlag: null,
      studentName: "",
      dataInfo: {},
      noteTaker: "", //记录人
      operationTypeInfo: {}, //操作的模块信息
      innerVisible: false,
      CloudStorageImage: [],
      Title: "",
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    this.dataInfo = JSON.parse(unescape(this.$route.query.dataInfo));
    this.FrontGetProceDetailInfo();
  },

  components: {
    prefabricatedText,
  },
  computed: {
    ...mapState({
      headerToken: (state) => state.token,
    }),
    headers() {
      return {
        Authorization: this.headerToken, // 直接从本地获取token就行
      };
    },
  },
  methods: {
    onClickList(Id) {},
    // 获取云盘照片
    async getCloudStorage() {
      let Dimension = 0;
      let CateName = this.operationTypeInfo.Name;
      if (CateName == "健康与体能") {
        Dimension = 1;
      } else if (CateName == "习惯与自理") {
        Dimension = 2;
      } else if (CateName == "自我与社会性") {
        Dimension = 3;
      } else if (CateName == "语言与交流") {
        Dimension = 4;
      } else if (CateName == "探究与认知") {
        Dimension = 5;
      } else if (CateName == "美感与表现") {
        Dimension = 6;
      }
      let xhr = await GetCloudFilePageingByFolderId({
        StudentId: this.dataInfo.StudentId,
        Dimension: Dimension,
        Type: 1, //文件类型 1.照片 2.视频
      });

      if (xhr.data.success) {
        xhr.data.response.data.forEach((element) => {
          element.isCheck = false;
        });
        this.CloudStorageImage = xhr.data.response.data;
      } else {
        this.CloudStorageImage = [];
      }
    },
    // 选择云盘图片
    selectImage(index) {
      this.CloudStorageImage[index].isCheck =
        !this.CloudStorageImage[index].isCheck;
    },
    // 确认选择云盘图片
    affirmSelectImage() {
      this.innerVisible = false;
      this.CloudStorageImage.forEach((item) => {
        if (item.isCheck) {
          if (this.imgFilesLists.length < 9) {
            this.imgFilesLists.push({
              url: item.FileUrl,
              name: "图片" + item.FileUrl,
              type: "image",
            });
          }
          item.isCheck = false;
        }
      });
    },
    showCloudStorage() {
      this.innerVisible = true;
    },
    coverContentSelect(e) {
      this.coverContent = e.content;
    },
    //   获取列表
    async FrontGetProceDetailInfo() {
      let xhr = await FrontGetProceDetailInfo({
        StudentId: this.dataInfo.StudentId,
        IsBaby: this.dataInfo.IsBaby,
        BabyLevel: this.dataInfo.BabyLevel,
        Id: this.dataInfo.Id,
      });
      if (xhr.data.success) {
        this.list = xhr.data.response;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    // 删除
    removeFileItem(index) {
      if (index >= 0) {
        this.imgFilesLists.splice(index, 1);
      }
    },
    //关闭
    async onClickClose(item) {
      let res = await FrontCloseProceDetailStatus({
        id: item,
      });
      if (res.data.success) {
        this.FrontGetProceDetailInfo();
      }
    },
    //开启
    async onClickOpen(item) {
      let res = await FrontOpenProceDetailStatus({
        id: item,
      });
      if (res.data.success) {
        this.FrontGetProceDetailInfo();
      }
    },

    btnConfirm() {
      this.$router.go(-1);
    },
    // 星星点击
    onClickRate(item, index) {
      this.params.List[index].isActivite = item;
    },

    handleUploadSuccess(response, file, fileList) {
      if (this.imgFilesLists.length >= 9) {
        this.$message({
          message: "最多上传9个",
          type: "error",
        });
        return;
      }
      //console.log(response, file);
      let FileType = file.raw.type.split("/");
      if (FileType[0] == "image") {
        this.imgFilesLists.push({
          url: response.response,
          name: "图片" + response.response,
          type: "image",
        });
      } else if (FileType[0] == "video") {
        this.imgFilesLists.push({
          url: response.response,
          name: "视频" + response.response,
          type: "video",
        });
      }
      //console.log(this.imgFilesLists, "this.imgFilesLists");
      this.$set(
        this,
        "imgFilesLists",
        JSON.parse(JSON.stringify(this.imgFilesLists))
      );
      if (this.loadingFlag) {
        this.loadingFlag.close();
        this.loadingFlag = undefined;
      }
    },

    beforeAvatarUpload(file) {
      if (this.imgFilesLists.length >= 9) {
        this.$message({
          message: "最多上传9张",
          type: "error",
        });
        return false;
      }
      let FileType = file.type.split("/");
      //console.log(FileType); //image video
      if (FileType[0] == "image" || FileType[0] == "video") {
        if (!this.loadingFlag) {
          this.loadingFlag = this.$loading({
            lock: true,
            text: "上传中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
        }
        return true;
      } else {
        this.$message.warning("请上传图片或视频");
        return false;
      }
    },

    //提交函数
    async submitFn() {
      let Content = "";
      let imgList = [];
      let videoArr = [];
      if (this.operationTypeInfo.Type == 1) {
        //操作人
        if (this.noteTaker.length == 0) {
          this.$message.warning("请输入操作人");
          return;
        } else {
          Content = this.noteTaker;
        }
      }
      if (this.operationTypeInfo.Type == 2) {
        //学期寄语
        if (this.coverContent.length == 0 && this.coverContent.length > 500) {
          this.$message.warning("请保持在500字以内");
          return;
        } else {
          Content = this.coverContent;
        }
      }
      if (this.operationTypeInfo.Type == 3) {
        //维度
        Content = this.coverContent;
        if (this.imgFilesLists.length == 0) {
          this.$message.warning("请上传图片或视频");
          return;
        } else if (this.imgFilesLists.length > 9) {
          this.$message.warning("请保持图片或视频的数量在9个以内");
          return;
        } else {
          this.imgFilesLists.forEach((item) => {
            if (item.type == "image") {
              imgList.push(item.url);
            } else if (item.type == "video") {
              videoArr.push(item.url);
            }
          });
        }
      }
      if (this.operationTypeInfo.Type == 4) {
        // 表格1
        if (this.tableParams.titleTab1 == "") {
          this.tableParams.titleTab1 = "姓名";
        }
        if (this.tableParams.titleTab2 == "") {
          this.tableParams.titleTab2 = "内容";
        }
        if (this.tableParams.titleTab3 == "") {
          this.tableParams.titleTab3 = "观察日期";
        }
        if (this.tableParams.titleTab4 == "") {
          this.tableParams.titleTab4 = "记录人";
        }
        Content = JSON.stringify(this.tableParams);
      }
      if (this.operationTypeInfo.Type == 5) {
        // 表格2
        let filt = this.params.List.filter((item) => {
          return item.manifestation.length != 0;
        });
        if (filt.length == 0) {
          this.$message.error("请编辑表格");
          return;
        }
        this.params.List = filt;
        Content = JSON.stringify(this.params);
      }
      let xhr = await FrontSaveProceDetailOneInfo({
        id: this.operationTypeInfo.Id,
        type: this.operationTypeInfo.Type,
        content: Content,
        cateName:
          this.operationTypeInfo.Type == 3
            ? this.operationTypeInfo.Name
            : undefined,
        imgList: imgList.join(","),
        audioList: "",
        videoList: videoArr.join(","),
      });
      if (xhr.data.success) {
        this.FrontGetProceDetailInfo();
        switch (this.operationTypeInfo.Type) {
          case 1:
            this.dialogVisible = false;
            break;
          case 2:
            this.dialogSend = false;
            break;
          case 3:
            this.dimensionality = false;
            break;
          case 4:
            this.dialogVisibleTable = false;

            break;
          case 5:
            this.dialogTableTwo = false;
            break;
        }
        this.$message.success("提交成功");
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    // 获取表格2标题
    async FrontGetTableTwoTitle() {
      let xhr = await FrontGetTableTwoTitle({
        StudentId: this.dataInfo.StudentId,
        Name: this.operationTypeInfo.Name + "表头",
      });
      if (xhr.data.success) {
        this.Title = xhr.data.response;
        console.log(this.Title);
      }
    },
    // 获取表格2题目
    async FrontGetProceQuestionInfo() {
      let xhr = await FrontGetProceQuestionInfo({
        StudentId: this.dataInfo.StudentId,
        Name: this.operationTypeInfo.Name,
      });
      if (xhr.data.success) {
        console.log(this.Title);

        this.params.title = this.Title;
        this.params.List = xhr.data.response.map((item) => {
          return {
            manifestation: item,
            isActivite: 1,
          };
        });
      }
    },
    // 编辑
    async onClickEdit(item) {
      this.operationTypeInfo = item;
      let xhr = await FrontGetProceDetailOneInfo({
        StudentId: this.dataInfo.StudentId,
        IsBaby: this.dataInfo.IsBaby,
        BabyLevel: this.dataInfo.BabyLevel,
        Id: item.Id,
      });
      if (xhr.data.success) {
        console.log(item.Type);
        let xhrData = xhr.data.response;
        // console.log(xhr.data.response, "xhr.data.response");
        switch (item.Type) {
          case 1:
            this.dialogVisible = true;
            this.studentName = xhrData.StudentName;
            this.className = xhrData.GradeName + xhrData.ClassName;
            this.noteTaker = xhrData.Content;
            break;
          case 2:
            this.dialogSend = true;
            this.coverContent = xhrData.Content;
            break;
          case 3:
            console.log(xhrData, "xhrData");

            this.getCloudStorage();
            this.dimensionality = true;
            this.imgFilesLists = [];
            let imageArr;
            let VideoList;
            if (xhrData.ImgList != "") {
              imageArr = xhrData.ImgList.split(",");
              imageArr.forEach((item) => {
                if (item) {
                  this.imgFilesLists.push({
                    url: item,
                    name: "图片" + item,
                    type: "image",
                  });
                }
              });
            }
            if (xhrData.VideoList != "") {
              VideoList = xhrData.VideoList.split(",");
              VideoList.forEach((item) => {
                if (item) {
                  this.imgFilesLists.push({
                    url: item,
                    name: "视频" + item,
                    type: "video",
                  });
                }
              });
            }

            this.coverContent = xhrData.Content;
            break;
          case 4:
            // this.tableId = item.Id;
            this.dialogVisibleTable = true;
            //console.log(xhrData.Content);
            try {
              this.tableParams = JSON.parse(xhrData.Content);
            } catch (error) {
              this.tableParams = {
                List: [
                  {
                    desc: "",
                    title: "学生表现",
                  },
                  {
                    desc: "",
                    title: "问题原因",
                  },
                  {
                    desc: "",
                    title: "解决问题计划",
                  },
                  {
                    desc: "",
                    title: "变化/成长",
                  },
                ],
                titleTab1: "",
                titleTab2: "",
                titleTab3: "",
                titleTab4: "",
                name: "",
                content: "",
                looktime: "",
                writename: "",
                performance: "",
                questionreason: "",
                Problemplan: "",
                change: "",
              };
            }
            break;
          case 5:
            // this.FrontGetTableTwoTitle();
            let res = await FrontGetTableTwoTitle({
              StudentId: this.dataInfo.StudentId,
              Name: this.operationTypeInfo.Name + "表头",
            });
            if (res.data.success) {
              this.Title = res.data.response;
              // console.log(this.Title);
              this.dialogTableTwo = true;
              console.log(this.Title, "Title");
              try {
                if (xhrData.Content) {
                  this.params = JSON.parse(xhrData.Content);

                  if (this.params.title == "") {
                    this.params.title = this.Title;
                    // debugger;
                  }
                } else {
                  this.FrontGetProceQuestionInfo();
                }
              } catch (error) {
                this.params = {
                  title: "",
                  List: [
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                    {
                      manifestation: "",
                      isActivite: 1,
                    },
                  ],
                };
              }
            }
            break;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.CloudStorageImageBox {
  display: flex;
  flex-wrap: wrap;
  .CloudStorageImageItem {
    width: 148px;
    height: 148px;
    position: relative;
    margin-top: 10px;
    margin-right: 10px;
    border: 1px #eeeeee solid;
    .check {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: #67c23a 1px solid;
      z-index: 2;
      position: absolute;
      top: 5px;
      right: 5px;
      div {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #67c23a;
        top: 50%;
        left: 50%;
        position: absolute;
        transform: translateX(-50%) translateY(-50%);
      }
    }
    img {
      width: 148px;
      height: 148px;
      object-fit: contain;
    }
  }
}
.el-icon-plus {
  display: block;
  width: 148px;
  height: 148px;
  font-size: 20px;
  border: 1px #ccc dashed;
  line-height: 148px;
  text-align: center;
}
.imgFilesLists {
  display: flex;
  flex-wrap: wrap;
  .fileItem {
    width: 148px;
    height: 148px;
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    img {
      width: 30px;
      height: 30px;
    }
    .el-icon-delete {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      font-size: 30px;
      color: #cccccc;
      z-index: 10;
      cursor: pointer;
    }
  }
}

.defaultIMage {
  position: relative;
  .itemName {
    width: 100%;
    position: absolute;
    min-height: 30px;
    top: 50%;
    left: 0;
    transform: translateY(-50%) !important;
    background-color: rgba(0, 0, 0, 0.3);
    font-size: 20px;
    font-weight: 600;
    color: #444;
  }
}
/deep/ .el-textarea__inner {
  border: 0;
  outline: none;
  resize: none;
  color: #000;
}
/deep/.el-input__inner::placeholder {
  color: #000;
  font-size: 14px;
}
/deep/.el-input__inner {
  border: 0;
}
/deep/.el-textarea__inner {
  border: 0;
  color: #000;
  resize: none; /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
  color: #000;
  font-size: 14px;
  background: none !important;
}
/deep/.el-textarea__inner::placeholder {
  color: #ccc;
  font-size: 14px;
}
/* 利用穿透，设置input边框隐藏 */
// .inputDeep >>> .el-input__inner {
//   border: 0;
// }
// /* 如果你的 el-input type 设置成textarea ，就要用这个了 */
// .inputDeep >>> .el-textarea__inner {
//   border: 0;
//   resize: none; /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
// }
.text-flex {
  width: 90px;
}
.templte {
  .add {
    display: flex;
    align-items: center;
    border: 1px solid #333;
    width: 140px;
    padding: 6px 0;
    border-radius: 10px;
    margin: 0 auto;
    justify-content: center;
    margin-top: 6px;
  }
  .flexs_dis {
    display: flex;
    justify-content: space-between;
    border: 1px dashed #333;
    margin-top: 4px;
    padding: 10px;
    border-radius: 4px;
    .li {
      font-weight: 600;
      cursor: pointer;
    }
    .icons {
      display: flex;
    }
  }
}
.btn-confirm {
  width: 290px;
  height: 50px;
  background: #4cbff4;
  color: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin: 0 auto;
}
.table-input {
  // width: 100%;
  height: 30px;
}
input {
  border: 0; // 去除未选中状态边框
  outline: none; // 去除选中状态边框
  background-color: rgba(0, 0, 0, 0); // 透明背景
}
.bd-top {
  border-top: 1px solid #000000;
}

.bd-bottom {
  border-bottom: 1px solid #000000;
}

.bd-left {
  border-left: 1px solid #000000;
}

.bd-right {
  border-right: 1px solid #000000;
}
.demo-el-col {
  height: 65px;
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;

  .table-textarea {
    width: 100%;
    font-size: 10px;
    font-weight: bold;
    color: #000000;
    padding-top: 10px;
    // margin: 0 auto;
  }
}

.statueTesting {
  width: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 0.25rem;
  .statueTesting_title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #343434;
    margin-right: 30px;
    &::before {
      content: "";
      width: 5px;
      height: 15px;
      background: #4cbff4;
      border-radius: 10px;
      display: inline-block;
      margin-right: 5px;
      position: relative;
      top: 3px;
    }
  }
}
.company-item {
  width: 58px;
  height: 29px;
  background: #4cbff4;
  border-radius: 5px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
}
.item-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  .Home-item {
    display: flex;
    align-items: center;
    margin: 10px;
    flex-direction: column;
    position: relative;
    background: #ffffff;
    // justify-content: center;

    .Home-time {
      position: relative;
      width: 150px;
      height: 220px;
      border: 1px solid #333333;
      color: #000;
      font-size: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      text-align: center;
      .times {
        width: 100%;
        height: 50px;
        background: rgba(52, 52, 52, 0.3);
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        color: #000;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        text-align: center;
      }
      .gray {
        /*grayscale(val):val值越大灰度就越深*/
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
      }
    }
  }
}
.hideAdd {
  /deep/ .el-upload--picture-card {
    display: none;
  }
}
</style>